import { produce, castDraft, immerable } from "immer";
import { FilterService } from "../../common/domain/service";
import { BaseModel } from "../../core/models";
import { type SourceModel } from "../models";
import { SourcesByType } from "./SourcesByType";

export class LensSourcesDomainModel {
    public [immerable] = true;
    public readonly filterService = new FilterService("");
    public readonly allSourcesGrouped: SourcesByType[] = [];
    public readonly filteredAllSourcesGrouped: SourcesByType[] = [];

    public get isAnySourceEnabled() {
        return this.allSourcesGrouped.some(({ sources }) => sources.length > 0);
    }

    public get hasFilteredResults() {
        return this.filteredAllSourcesGrouped.some(({ sources }) => sources.length > 0);
    }
}

export const LensSourcesDomainModelFunctions = {
    filter(model: LensSourcesDomainModel, newValue: string): LensSourcesDomainModel {
        return produce(model, (draft) => {
            draft.filterService = new FilterService(newValue);

            draft.filteredAllSourcesGrouped = castDraft(
                draft.allSourcesGrouped.map((sourcesByType) =>
                    BaseModel.createInstance(SourcesByType, {
                        ...sourcesByType,
                        sources: castDraft(
                            draft.filterService.applyFilter<SourceModel>(
                                sourcesByType.sources,
                                (source) => source.name,
                            ),
                        ),
                    }),
                ),
            ) as SourcesByType[];
        });
    },
};
